import merge from 'lodash-es/merge';
import { palette } from './palette';
export const weights = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
};
export const fonts = {
    weights,
    fontFamily: 'Roboto',
    h1: {
        color: '#000',
        fontSize: '20px',
        fontWeight: weights.regular,
        letterSpacing: '0.29px',
        lineHeight: '24px',
    },
    h2: {
        fontSize: '20px',
        fontWeight: weights.light,
        letterSpacing: '0.12px',
        lineHeight: '29px',
    },
    h3: {
        fontSize: '17px',
        fontWeight: weights.medium,
        letterSpacing: '0.1px',
        lineHeight: '27px',
    },
    h4: {
        fontSize: '15px',
        fontWeight: weights.medium,
        letterSpacing: '0.1px',
        lineHeight: '26px',
    },
    h5: {
        fontSize: '14px',
        fontWeight: weights.bold,
        letterSpacing: '0.1px',
        lineHeight: '26px',
    },
    h6: {
        fontSize: '13px',
        fontWeight: weights.medium,
        letterSpacing: '0.4px',
        lineHeight: '16px',
    },
    body2: {
        fontSize: '12px',
        lineHeight: '17px',
        letterSpacing: '0.1px',
    },
    body1: {
        fontSize: '16px',
        lineHeight: '1.5',
        fontWeight: weights.regular,
        letterSpacing: '0.1px',
    },
    breadcrumb: {
        fontSize: '11px',
        lineHeight: '13px',
        letterSpacing: '0.12px',
    },
    tableHeader: {
        fontSize: '14px',
        fontWeight: weights.medium,
        lineHeight: '16px',
        letterSpacing: '0.4px',
    },
    userName: {
        fontSize: '13px',
        lineHeight: '15px',
        fontWeight: weights.regular,
    },
    userRole: {
        fontSize: '9.5px',
        lineHeight: '11px',
        letterSpacing: '0.1px',
        fontWeight: weights.regular,
    },
    widget2Heading: {
        fontSize: '17px',
        fontWeight: weights.regular,
        lineHeight: '20px',
        letterSpacing: '0.2px',
    },
    inputLabel: {
        fontSize: '13px',
        lineHeight: '15px',
    },
    navItem: {
        fontSize: '14px',
        letterSpacing: '0.38px',
        lineHeight: '21px',
    },
    button: {
        fontSize: '13px',
        letterSpacing: '0.93px',
        lineHeight: '14px',
        fontWeight: weights.regular,
    },
    boldNumber: {
        fontSize: '20px',
        fontWeight: weights.bold,
        letterSpacing: '0.1px',
        lineHeight: '24px',
    },
    fieldLabel: {
        fontSize: '14px',
        fontWeight: weights.medium,
        letterSpacing: '0.22px',
    },
    fieldAdornment: {
        fontSize: '11px',
        fontWeight: weights.regular,
    },
    errorMessage: {
        fontSize: '11px',
        fontWeight: weights.regular,
    },
    tileTitle: {
        fontSize: '15px',
        fontWeight: weights.regular,
    },
    a: {
        textDecoration: 'underline',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    chip: {
        fontSize: '10px',
        fontWeight: weights.medium,
        letterSpacing: '0.83px',
        lineHeight: '14px',
    },
    menuOption: {
        fontSize: '13px',
        fontWeight: weights.regular,
        letterSpacing: '0.4px',
        lineHeight: '16px',
    },
    tooltipText: {
        fontSize: '12px',
        lineHeight: '17px',
        fontWeight: weights.regular,
        letterSpacing: '0.2px',
    },
    comment: {
        fontSize: '13px',
        letterSpacing: '0.15px',
        lineHeight: '21px',
        fontWeight: weights.regular,
    },
    commentSuggestions: {
        fontSize: '14px',
        letterSpacing: '0.1px',
        lineHeight: '21px',
        fontWeight: weights.regular,
    },
    linkText: {
        fontSize: '12px',
        fontWeight: weights.medium,
        letterSpacing: '0.1px',
        lineHeight: '17px',
        textDecoration: 'underline',
    },
};
export const mySeequentTypographyOptions = {
    h1: {
        fontSize: '38px',
        lineHeight: '44px',
        letterSpacing: '0.29px',
        fontWeight: weights.regular,
        color: '#FFFFFF',
    },
    h2: {
        fontSize: '25px',
        lineHeight: '29px',
        letterSpacing: '-0.41px',
        fontWeight: weights.light,
        color: palette.grey[800],
    },
    h3: {
        fontSize: '18px',
        lineHeight: '25px',
        letterSpacing: '0.41px',
        fontWeight: weights.regular,
        color: palette.primary.main,
    },
    h4: {
        fontSize: '16px',
        lineHeight: '16px',
        letterSpacing: '0.13px',
        fontWeight: weights.regular,
        color: palette.primary.main,
    },
    h5: {
        fontSize: '13px',
        lineHeight: '17px',
        letterSpacing: '0.43px',
        fontWeight: weights.medium,
        color: palette.grey[800],
    },
    subtitle1: {
        fontSize: '20px',
        lineHeight: '24px',
        letterSpacing: '0.1px',
        fontWeight: weights.regular,
        color: palette.grey[800],
    },
    subtitle2: {
        fontSize: '16px',
        lineHeight: '21px',
        letterSpacing: '0.1px',
        fontWeight: weights.medium,
        color: '#30343E',
    },
    lead: {
        fontSize: '18px',
        lineHeight: '27px',
        letterSpacing: '-0.29px',
        fontWeight: weights.light,
        color: palette.grey[800],
    },
    body1: {
        fontSize: '14px',
        lineHeight: '21px',
        letterSpacing: '0.1px',
        fontWeight: weights.regular,
        color: palette.grey[700],
    },
    body2: {
        fontSize: '13px',
        lineHeight: '21px',
        letterSpacing: '0.1px',
        fontWeight: weights.regular,
        color: palette.grey[700],
    },
    small: {
        fontSize: '12px',
        lineHeight: '21px',
        letterSpacing: '0',
        fontWeight: weights.regular,
        color: palette.grey[700],
    },
    tab: {
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '0.96px',
        fontWeight: weights.regular,
        color: palette.grey[600],
        textTransform: 'uppercase',
    },
    navItem: {
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '0.5px',
        fontWeight: weights.regular,
        color: palette.grey[700],
        textTransform: 'uppercase',
    },
    childNavItem: {
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '0.5px',
        fontWeight: weights.regular,
        color: palette.grey[700],
        textTransform: 'uppercase',
    },
};
export const mySeequentFonts = merge({}, fonts, mySeequentTypographyOptions);
//# sourceMappingURL=fonts.js.map